define("Ames.RotateImages.RotateImages", [
  "Ames.RotateImages.RotateImages.View",
  "ProductDetails.ImageGallery.View.Extension"
], function (RotateImagesView) {
  "use strict";

  return {
    mountToApp: function mountToApp(container) {
      var layout = container.getComponent("Layout");
      var self = this;

      if (layout) {
        layout.on("afterShowContent", function () {
          self.loadScript();
        });

        // layout.addChildView("Product.ImageGallery", function () {
        //   return new RotateImagesView({ container: container });
        // });
      }

    //   layout.addToViewContextDefinition(
    //     "ProductDetails.ImageGallery.View",
    //     "showImages",
    //     "boolean",
    //     function (context) {
    //       return false;
    //     }
    //   );
    },
    loadScript: function loadScript() {
      (function () {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.src =
          "https://scaleflex.cloudimg.io/v7/plugins/js-cloudimage-360-view/latest/js-cloudimage-360-view.min.js?func=proxy";
        var firstScript = document.getElementsByTagName("script")[0];
        firstScript.parentNode.insertBefore(script, firstScript);
      })();
    },
  };
});
